import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	subject: {
		fontWeight: 'bold'
	},
	dialogContent: {
		flex: 'unset'
	},
	dialogActions: {
		justifyContent: 'center'
	},
	openNotification: {
		color: theme.palette.common.white
	},
	closeModal: {
		width: '8rem',
		height: '3rem'
	},
	actionButton: {
		width: '8rem',
        height: '3rem',
        borderRadius: '0'
    },
    cancelButton: {
        width: '8rem',
        height: '3rem',
		borderRadius: '0',
		border: '2px solid',
		opacity: '0.4',
		boxSizing: 'border-box',
		borderColor: theme.palette.common.white,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.black
    }
}));

export default useStyles;
